import { render, staticRenderFns } from "./logoFrame.vue?vue&type=template&id=e00bf9e2&scoped=true"
import script from "./logoFrame.vue?vue&type=script&lang=js"
export * from "./logoFrame.vue?vue&type=script&lang=js"
import style0 from "./logoFrame.vue?vue&type=style&index=0&id=e00bf9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00bf9e2",
  null
  
)

export default component.exports